import { render, staticRenderFns } from "./Act.vue?vue&type=template&id=c0e8ce0a&"
import script from "./Act.vue?vue&type=script&lang=js&"
export * from "./Act.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports